<template>
    <aside class="col-md-2 position-relative" dusk="side-navigation">
        <nav v-if="!hideDesktop" class="menu-parent d-none d-md-block pl-0">
            <ul class="side-menu pl-0" role="menu">
                <li
                    v-if="header"
                    class="menu-item px-3 pt-3 border-bottom cursor-pointer"
                    @click="$emit('set-parent-prop', ['component', parentComponent])"
                >
                    <h6
                        class="menu-title patient-name py-3"
                        :class="[
                            {
                                'font-weight-bold text-black': isCurrentComponent(parentComponent),
                                'text-dark': !isCurrentComponent(parentComponent),
                            },
                        ]"
                    >
                        {{ header }}
                    </h6>
                </li>
                <li
                    class="menu-item pt-3 pb-2 px-3 text-dark cursor-pointer"
                    :class="
                        (m.hasOwnProperty('items') && m.items.length) || !m.title
                            ? ''
                            : 'border-bottom'
                    "
                    v-for="(m, idx) in sideMenuItemsAllowed"
                    :key="`li-${idx}-${m.title}`"
                    v-bind:style="m.hasOwnProperty('domain') ? getGoalStyle(m.domain.color) : ''"
                    @click.stop="goMenuItem(m)"
                >
                    <h6 class="m-0">
                        <a
                            class="menu-title"
                            :id="'menu-' + m.title.toLowerCase().replace(/\s/g, '-')"
                            :class="[
                                m.class,
                                {
                                    'font-weight-bold text-black': isCurrentComponent(m),
                                    'text-dark spacing-05': !isCurrentComponent(m),
                                },
                            ]"
                            :href="m.url"
                            role="button"
                            aria-expanded="false"
                            >{{ m.title }}</a
                        >
                    </h6>
                    <div v-if="m.items" class="cursor-pointer" :id="`${m.title}`">
                        <p
                            v-for="(it, idx) in m.items"
                            class="py-2 pl-3 mb-0 menu-title border-bottom"
                            :id="it.title.toLowerCase().replace(/[\s\/]/g, '-')"
                            :class="[
                                it.class,
                                {
                                    'font-weight-bold text-black': isCurrentComponent(it),
                                    'text-dark': !isCurrentComponent(it),
                                },
                            ]"
                            :href="it.url ? it.url : null"
                            :key="`p-${it.idx}-${it.title}`"
                            @click.stop="
                                it.component
                                    ? $emit('set-parent-prop', ['component', it.component])
                                    : null
                            "
                        >
                            {{ it.title }}
                        </p>
                    </div>
                </li>
            </ul>
        </nav>

        <!--MOBILE-->
        <transition name="slide-left">
            <nav v-if="showSideMenu" class="position-absolute bg-white pl-3 w-100 side-menu-mobile">
                <div class="menu-parent position-relative">
                    <ul
                        :class="mobileLevel === 2 ? 'shift-left' : ''"
                        class="menu-level side-menu pl-0 position-absolute w-100 bg-white"
                        role="menu"
                        id="menu-level-1"
                    >
                        <li
                            v-if="header"
                            class="menu-item px-3 pt-3 border-bottom cursor-pointer"
                            @click="$emit('set-parent-prop', ['component', parentComponent])"
                        >
                            <h6
                                class="menu-title patient-name py-3"
                                :class="[
                                    {
                                        'font-weight-bold text-black': isCurrentComponent(
                                            parentComponent
                                        ),
                                        'text-dark': !isCurrentComponent(parentComponent),
                                    },
                                ]"
                            >
                                {{ header }}
                            </h6>
                        </li>
                        <li
                            class="menu-item pt-3 pb-2 px-3 text-dark cursor-pointer"
                            :class="
                                (m.hasOwnProperty('items') && m.items.length) || !m.title ? '' : ''
                            "
                            v-for="(m, idx) in sideMenuItemsAllowed"
                            :key="`li-${idx}-${m.title}`"
                            @click.stop="goMenuItem(m)"
                        >
                            <h6 class="m-0 d-flex justify-content-between align-items-center">
                                <a
                                    class="menu-title"
                                    :id="'menu-' + m.title.toLowerCase().replace(/\s/g, '-')"
                                    :class="[
                                        m.class,
                                        {
                                            'font-weight-bold text-black':
                                                (m.hasOwnProperty('items') && m.items.length) ||
                                                isCurrentComponent(m),
                                            'text-dark spacing-05': !(
                                                m.hasOwnProperty('items') && m.items.length
                                            ),
                                        },
                                    ]"
                                    :href="m.url"
                                    role="button"
                                    aria-expanded="false"
                                >
                                    {{ m.title }}
                                </a>
                                <i
                                    v-if="m.hasOwnProperty('items') && m.items.length"
                                    class="fa fa-angle-right font-weight-bold"
                                ></i>
                            </h6>
                        </li>
                    </ul>

                    <ul
                        :class="mobileLevel === 1 ? 'shift-right' : ''"
                        class="menu-level side-menu pl-0 position-absolute w-100 bg-white"
                        role="menu"
                        id="menu-level-2"
                    >
                        <li
                            class="menu-item pt-3 pb-2 px-3 text-dark cursor-pointer"
                            :key="`menu-level2-title`"
                            @click.stop="goMenuBack()"
                        >
                            <h6 class="m-0 d-flex justify-content-start align-items-center">
                                <i class="fa fa-fw fa-angle-left font-weight-bold mr-3"></i>
                                <a class="menu-title font-weight-bold text-black">
                                    {{ level2Menu.title }}
                                </a>
                            </h6>
                        </li>

                        <template v-for="(item, index) in level2Menu.items">
                            <li class="cursor-pointer" :id="`${item.title}`">
                                <p
                                    class="py-2 px-3 mb-0 menu-title d-flex justify-content-start align-items-center"
                                    :class="[
                                        item.class,
                                        {
                                            'font-weight-bold text-black':
                                                isCurrentComponent(item) ||
                                                isCurrentComponent(item),
                                            'text-dark': !isCurrentComponent(item),
                                        },
                                    ]"
                                    :href="item.url ? item.url : null"
                                    :key="`p-${index}-${item.title}`"
                                    @click.stop="goSubItem(item, index)"
                                >
                                    <i class="fa fa-fw mr-3"></i>
                                    <span>{{ item.title }}</span>
                                    <i
                                        v-if="item.hasOwnProperty('items') && item.items.length"
                                        class=" ml-auto fa font-weight-bold"
                                        :class="openSub === index ? 'fa-minus' : 'fa-plus'"
                                    ></i>
                                </p>
                            </li>
                            <transition-group name="squish-vert-fade">
                                <template v-if="openSub === index">
                                    <li
                                        v-for="(subItem, subIndex) in item.items"
                                        class="cursor-pointer"
                                        :id="`${subItem.title}`"
                                        :key="`sub-open-${subIndex}`"
                                    >
                                        <p
                                            class="py-2 px-4 mb-0 menu-title d-flex justify-content-start align-items-center text-dark"
                                            :href="subItem.url ? subItem.url : null"
                                            :key="`p-${index}-${subIndex}-${subItem.title}`"
                                            @click.stop="goSubItem(subItem)"
                                        >
                                            <i class="fa fa-fw mr-3"></i>
                                            <span>{{ subItem.title }}</span>
                                            <i
                                                v-if="
                                                    subItem.hasOwnProperty('items') &&
                                                        subItem.items.length
                                                "
                                                class=" ml-auto fa fa-plus font-weight-bold"
                                            ></i>
                                        </p>
                                    </li>
                                </template>
                            </transition-group>
                        </template>
                    </ul>
                </div>
            </nav>
        </transition>
    </aside>
</template>
<script>
import { sideMenuItems } from "../plugins/sideMenuItems";
import { helpers } from "../plugins/helpers";

export default {
    name: "GoLotusSideMenu",
    props: [
        "sideMenuItems",
        "header",
        "topLevelProperty",
        "parentComponent",
        "currentComponent",
        "hideDesktop",
    ],
    mixins: [sideMenuItems],
    data() {
        return {
            helpers,
            mobileLevel: 1,
            level2Menu: { title: "" },
            openSub: null,
        };
    },
    computed: {
        sideMenuItemsAllowed() {
            return this.sideMenuItems.filter(item => {
                if (
                    item.hasOwnProperty("shouldDisplay") &&
                    typeof (item.shouldDisplay === "function")
                ) {
                    return item.shouldDisplay();
                }
                return true;
            });
        },
    },
    watch: {
        showSideMenu() {
            if (!this.showSideMenu) {
                this.mobileLevel = 1;
                this.level2Menu = { title: "" };
                this.openSub = null;
            }
        },
    },
    methods: {
        goMenuBack() {
            this.mobileLevel = 1;
            this.openSub = null;
        },

        goMenuItem(item) {
            if (this.mobileLevel === 1 && item.hasOwnProperty("items") && item.items.length) {
                this.mobileLevel = 2;
                this.level2Menu = item;
                return;
            }
            if (item.component) {
                this.$emit("set-parent-prop", ["component", item.component]);
            } else {
                this.$emit("set-parent-prop", [this.topLevelProperty, item]);
            }
            if (item.url) {
                helpers.goLink(item.url);
            }
        },
        goSubItem(item, index) {
            if (item.hasOwnProperty("items") && item.items.length) {
                if (this.openSub === index) {
                    this.openSub = null;
                } else {
                    this.openSub = index;
                }
                return;
            }
            if (item.component) {
                this.$emit("set-parent-prop", ["component", item.component]);
            }
            if (item.hasOwnProperty("tracker_type")) {
                // If item is a goal, workaround to redirect user to goal page
                item.url = `/patients/${item.patient_id}/goals?goal=${item.id}`;
            }
            if (item.url) {
                helpers.goLink(item.url);
            }
        },
        getGoalStyle(color) {
            return {
                "-webkit-box-shadow": "inset 4px 0 0 0 " + color,
                "box-shadow": "inset 4px 0 0 0 " + color,
            };
        },
        isCurrentComponent(m) {
            //Child components
            if (
                m.hasOwnProperty("component") &&
                (this.currentComponent === m.component ||
                    (this.parentComponent === m.component && !this.currentComponent))
            ) {
                return true;
            }
            //Goals
            if (m.hasOwnProperty("id") && this.currentComponent === m.id) {
                return true;
            }
            //Pages (parent components)
            if (window && m.url === "/" + window.location.href.split("/").pop()) {
                return true;
            }
            //Detail pages (parent components)
            if (window && m.url === "/" + window.location.pathname.split("/")[1]) {
                return true;
            }
            //Header
            if (this.currentComponent === m) {
                return true;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.separator {
    max-height: 0.8rem;
    border: none !important;
}
.patient-name {
    text-transform: uppercase;
    font-size: 0.9rem !important;
    font-weight: bold !important;
}
.footer {
    > h6 {
        font-size: 80%;
    }
}
.separator {
    max-height: 0.8rem;
}
.footer {
    > h6 {
        font-size: 80%;
    }
}
.separator {
    max-height: 0.8rem;
}
.footer {
    > h6 {
        font-size: 80%;
    }
}

.side-menu {
    transition: all 0.6s;
    list-style-type: none;
    box-shadow: 0 20px 0 20px white;
    > .menu-item > h6 > a:hover {
        text-decoration: none;
    }
    > .menu-item {
        font-weight: 500;
    }
}

.menu-title {
    font-size: 90%;
}

.menu-level {
    transition: all 0.5s ease;
    transform: translateX(0);
}

.shift-left {
    transform: translateX(-100vw) !important;
}

.shift-right {
    transform: translateX(100vw) !important;
}

@media screen and (min-width: 768px) {
    .side-menu {
        box-shadow: unset;
    }
}
</style>
